import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useLocation } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastProvider } from '@/components/ui/Toast'
import { ThemeProvider } from '@/providers/ThemeProvider'
import { AppBootstrapGate } from '@/components/AppBootstrapGate'
import { MaintenanceGate } from '@/components/MaintenanceGate'
import App from './App'
import './lib/i18n' // Initialize i18n
import '@shared/cms-layout.css'
import './index.css'

/** Scroll to top on route change (BrowserRouter-compatible). */
function ScrollToTopOnNavigate() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])
  return null
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTopOnNavigate />
        <ThemeProvider>
          <AppBootstrapGate>
            <MaintenanceGate>
              <ToastProvider>
                <App />
              </ToastProvider>
            </MaintenanceGate>
          </AppBootstrapGate>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
